import { memo } from "react";
import { useTranslation } from "react-i18next";

const KEY_CLASS_NAME =
  "rounded border border-input bg-muted px-1.5 py-0.5 font-mono text-[10px] text-foreground";

// NOTE: The keyboard contract of the palette, spelled out. Hidden on narrow
// screens, where nobody drives it from a keyboard.
const GlobalSearchFooterComponent = (): JSX.Element => {
  const { t } = useTranslation("globalSearch");

  return (
    <div
      className="hidden sm:flex items-center justify-end gap-4 border-t border-input px-4 py-2 text-xs text-foreground-secondary"
      data-testid="global-search-footer"
    >
      <span className="flex items-center gap-1.5">
        <kbd className={KEY_CLASS_NAME}>↑</kbd>
        <kbd className={KEY_CLASS_NAME}>↓</kbd>
        {t("keyboard.navigate")}
      </span>
      <span className="flex items-center gap-1.5">
        <kbd className={KEY_CLASS_NAME}>↵</kbd>
        {t("keyboard.open")}
      </span>
      <span className="flex items-center gap-1.5">
        <kbd className={KEY_CLASS_NAME}>Esc</kbd>
        {t("keyboard.close")}
      </span>
    </div>
  );
};

export const GlobalSearchFooter = memo(GlobalSearchFooterComponent);
